const featureFlags = {
    USE_NEW_GET_COUNT_FUNCTION: false,
    SUB_GROUP_LIST_WITH_CLIENT_NAMES: false
};

module.exports = featureFlags;
